import { environment } from '../../../environments/environment.local';

export const cargoTypeUriTemplate = (cargoTypeId?: string): string => {
  return `${environment.API.CARGO_TYPES_URI}/${cargoTypeId}`;
};
